export const GESTURE = 'gesture'
export const REVERT_GESTURE = 'revert_gesture'
